module.exports = __webpack_public_path__ + "assets/img/help_prev_hover.5becc650.svg";